import { type ComponentType, type LazyExoticComponent, lazy } from 'react';

// Layar dimuat terpisah (lazy) + bisa dimuat lebih dulu di latar belakang (preload) setelah login,
// agar pindah menu tidak menunggu unduhan kode layar (terasa "diam" di HP / jaringan lambat).

export type LazyView = LazyExoticComponent<ComponentType> & { preload: () => Promise<unknown> };

export function lazyView(factory: () => Promise<{ default: ComponentType }>): LazyView {
  let p: Promise<{ default: ComponentType }> | null = null;
  const load = () => {
    p ??= factory();
    return p;
  };
  const C = lazy(load) as LazyView;
  C.preload = load;
  return C;
}

export const isLazyView = (c: unknown): c is LazyView => typeof (c as LazyView)?.preload === 'function';
